// @module Dev.ShoppingActions.ShoppingActionsModule
define('Dev.ShoppingActions.ShoppingActionsModule.CutLinkOptionView'
,	[
	'dev_shoppingactions_shoppingactionscutlinkoption.tpl'
	
	,	'Backbone'
	,	'jQuery'
    ]
, function (
		dev_shoppingactions_shoppingactionsmodule_cutlinkoption_tpl
	
	,	Backbone
	,	JQuery
)
{
    'use strict';

	// @class Dev.ShoppingActions.ShoppingActionsModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: dev_shoppingactions_shoppingactionsmodule_cutlinkoption_tpl

	,	initialize: function (options) {
      		this.pdp_comp=options.pdp;
		}

	,	events: {
			'blur [data-action="cut-link-option"]': 'setCutLinkOption'
		}

	,	setCutLinkOption: function setCutLinkOption(e){
			// debugger;
			var value=e.currentTarget.value;
			if(value){
				this.pdp_comp.setOption('custcol_web_cut_link', value);
			}
			else{
				this.pdp_comp.setOption('custcol_web_cut_link', '');
			}
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Dev.ShoppingActions.ShoppingActionsModule.View.Context
	,	getContext: function getContext()
		{
			var is_show_option=this.pdp_comp.getItemInfo().item.custitem_show_cut_link_on_pdp_page;
			SC.is_show_cut_option=is_show_option;
			return {
				message: "hello",
				is_show_option: is_show_option
			} 
		}
	});
});
